var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32C17.957 32 19.8318 31.648 21.5651 31.0048L22.2607 16L21.5651 0.995188C19.8318 0.352063 17.957 0 15.9999 0C14.0428 0 12.1679 0.352063 10.4347 0.995188L9.73901 16L10.4346 31.0048C12.1679 31.648 14.0428 32 15.9999 32Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 22.8795 4.342 28.7442 10.4348 31.0049V0.995239C4.342 3.25593 0 9.12061 0 16.0001Z",
    fill: "#A2001D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 0.995239V31.0049C27.658 28.7442 32 22.8795 32 16.0001C32 9.12061 27.658 3.25593 21.5652 0.995239V0.995239Z",
    fill: "#A2001D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65259 16H9.0439V21.5652H7.65259V16Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0874 16H3.47871V21.5652H2.0874V16Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56612 19.4784C6.33452 19.4784 6.95743 18.8555 6.95743 18.0871C6.95743 17.3187 6.33452 16.6958 5.56612 16.6958C4.79772 16.6958 4.1748 17.3187 4.1748 18.0871C4.1748 18.8555 4.79772 19.4784 5.56612 19.4784Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56525 13.9131C5.94944 13.9131 6.26088 13.6017 6.26088 13.2175C6.26088 12.8333 5.94944 12.5219 5.56525 12.5219C5.18107 12.5219 4.86963 12.8333 4.86963 13.2175C4.86963 13.6017 5.18107 13.9131 5.56525 13.9131Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1748 20.174H6.95743V21.5653H4.1748V20.174Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1748 14.6087H6.95743V16H4.1748V14.6087Z",
    fill: "#FFDA44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56594 8.3479L6.05869 9.86415H7.65294L6.36325 10.8013L6.85563 12.3175L5.56594 11.3804L4.27632 12.3175L4.76869 10.8013L3.479 9.86415H5.07325L5.56594 8.3479Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongolia);
export default __webpack_public_path__ + "static/media/mongolia.f2be751b.svg";
export { ForwardRef as ReactComponent };